import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'status' })
export class StatusPipe implements PipeTransform {
  status = {
    true: 'Active',
    false: 'Inactive'
  }

  transform(key: string | boolean): any {
    key = String(key);
    if(this.status[key]) {
      return this.status[key]
    }
    return key
  }
}
